import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const LOGO_URL = "/images/basic-united-logo.jpg";

const T = {
  headline: { de: 'Vereint. Stark. Verlässlich.', en: 'United. Strong. Reliable.' },
  sub: {
    de: 'Basic United Holding GmbH – Ihre Muttergesellschaft für innovative Unternehmenslösungen in Logistik, Beratung und Dienstleistungen.',
    en: 'Basic United Holding GmbH – Your parent company for innovative business solutions in logistics, consulting and services.',
  },
  ctaPrimary: { de: 'Unsere Unternehmen', en: 'Our Companies' },
  ctaSecondary: { de: 'Kontakt aufnehmen', en: 'Get in Touch' },
};

export const HeroSection = () => {
  const { language } = useLanguage();

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-[#0F1A2E]">
        <div className="absolute inset-0 opacity-10">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
                <path d="M 60 0 L 0 0 0 60" fill="none" stroke="white" strokeWidth="0.5"/>
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
          </svg>
        </div>
        <div className="absolute top-20 right-10 w-64 h-64 bg-[#F5A623] opacity-5 transform rotate-45"></div>
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-white opacity-5 transform -rotate-12"></div>
      </div>

      <div className="relative container-main text-center text-white z-10 pt-20">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }}>
          <div className="flex justify-center mb-10">
            <Link to="/" data-testid="hero-logo-link">
              <img 
                src={LOGO_URL} 
                alt="Basic United Holding GmbH" 
                className="h-20 md:h-28 lg:h-32 w-auto"
                data-testid="hero-logo"
              />
            </Link>
          </div>
          <div className="flex justify-center mb-8"><div className="accent-line"></div></div>
          <h1 className="font-heading heading-hero font-bold tracking-tight mb-6">{T.headline[language]}</h1>
          <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">{T.sub[language]}</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/unternehmen" data-testid="hero-cta-primary" className="bg-white text-[#0F1A2E] px-8 py-4 text-sm tracking-widest uppercase font-semibold hover:bg-[#F5A623] hover:text-white transition-colors duration-300">
              {T.ctaPrimary[language]}
            </Link>
            <Link to="/kontakt" data-testid="hero-cta-secondary" className="bg-transparent border border-white text-white px-8 py-4 text-sm tracking-widest uppercase font-semibold hover:bg-white hover:text-[#0F1A2E] transition-colors duration-300">
              {T.ctaSecondary[language]}
            </Link>
          </div>
        </motion.div>
      </div>

      <motion.div className="absolute bottom-10 left-1/2 transform -translate-x-1/2" animate={{ y: [0, 10, 0] }} transition={{ duration: 2, repeat: Infinity }}>
        <ChevronDown size={32} className="text-white/50" />
      </motion.div>
    </section>
  );
};

export default HeroSection;
